import { Select } from "antd";
import { useState } from "react";
import { Option } from "antd/es/mentions";
import styles from "./styles.module.scss";
import { ReactComponent as DropdownArrow } from "icons/dropdownArrow.svg";

interface CustomSelectProps {
  optionsArray: string[];
  value: string;
  onChange: any;
  style?: { [key: string]: React.CSSProperties };
  variant: string;
  defaultValue?: string | undefined;
  iconHeight?: any;
  iconWidth?: any;
}

export function CustomSelect({
  optionsArray,
  value,
  onChange,
  style,
  variant,
  defaultValue,
  iconHeight,
  iconWidth,
}: CustomSelectProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (!Array.isArray(optionsArray)) {
    return <></>;
  }

  const iconSize =
    iconHeight && iconWidth
      ? {
          height: iconHeight,
          width: iconWidth,
        }
      : undefined;

  return (
    <Select
      placeholder={!defaultValue && "Select"}
      defaultValue={!defaultValue ? undefined : optionsArray[0]}
      value={value}
      className={`${styles.customSelectMain} ${styles[variant]}`}
      style={style?.select}
      onChange={onChange}
      onDropdownVisibleChange={() => setIsOpen((prev) => !prev)}
      suffixIcon={
        <DropdownArrow
          className={styles[isOpen ? "closed" : "opened"]}
          {...iconSize}
        />
      }
    >
      {optionsArray.map((option: any) => {
        return (
          <Option key={option} value={option} style={style?.option}>
            {option}
          </Option>
        );
      })}
    </Select>
  );
}
